<template>
    <div class="relative shadow-md z-20 w-full bg-white rounded-lg" :class="[stickHeaderOnScroll ? 'stick-below-nav' : '',]">
        <div class="w-full px-4 pt-3 pb-4 rounded-lg">
            <div class="md:flex md:items-center md:justify-between md:space-x-4 p-1">
                <div class="md:flex md:items-start md:justify-between md:space-x-4 gap-4">
                    <slot name="top-panel-left"></slot>
                </div>

                <!-- Custom top right section left of Show Filters Button -->
                <div
                    class="mt-3 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-reverse sm:space-y-0 sm:space-x-3 md:mt-0 md:flex-row md:space-x-3">
                    <slot name="top-panel-right"></slot>

                    <button type="button" v-if="showExpandOption"
                            class="min-width-150 inline-flex justify-center items-center w-full rounded-md py-2 bg-white text-sm font-medium text-indigo-600 hover:bg-gray-50 hover:text-indigo-500 transition duration-300 focus:outline-none  px-4"
                            @click.prevent="toggleAdvancedFilters()">
                        <icon-filter v-show="!showAdvancedFilters && showExpandOption"
                                     class="transform transition-all ease-in-out duration-400 h-5 w-5 mr-2"></icon-filter>
                        <icon-chevron-down v-show="showAdvancedFilters && showExpandOption"
                                           class="transform transition-all ease-in-out duration-400 rotate-180 h-5 w-5 mr-2"></icon-chevron-down>
                        {{ showAdvancedFilters ? "Hide Filters" : filterButtonText }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Expanded Filters Section -->
        <transition name="slide">
            <div v-show="showAdvancedFilters && showExpandOption" class="relative z-10 transform rounded-b-lg border-t-2 border-gray-100">
                <slot name="expanded-filters-container"></slot>
                <div class="rounded-b-lg border-t-2 border-gray-100">
                    <div class="mx-auto space-y-6 px-4 py-6 sm:flex justify-end sm:space-y-0 sm:space-x-10 px-6">
                        <slot name="expanded-filters-container-footer"></slot>
                        <slot name="expanded-filters-container-footer-overwrite">
                            <div class="flow-root">
                                <button @click.prevent="$emit('reset-filters')"
                                        class="-m-3 p-3 flex items-center rounded-md font-medium text-gray-900 hover:bg-gray-100 transition ease-in-out duration-150">
                                    <!-- Heroicon name: outline/check-circle -->
                                    <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         stroke="currentColor" aria-hidden="true">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                                    </svg>
                                    <span class="ml-3">Reset Filters</span>
                                </button>
                            </div>
                            <div class="flow-root">
                                <button @click.prevent="applyFilters()"
                                        class="-m-3 p-3 outline-none flex items-center rounded-md font-medium text-gray-900 transition bg-indigo-100 hover:bg-indigo-50 ease-in-out duration-150 text-indigo-600">
                                    <!-- Heroicon name: outline/play -->
                                    <svg class="flex-shrink-0 h-5 w-5 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         stroke="currentColor" aria-hidden="true">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
                                    </svg>
                                    <span class="ml-3">Apply Filters</span>
                                </button>
                            </div>
                        </slot>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "ExpandableFiltersContainer",
    props: {
        filterButtonText: {
            required: false,
            default: "More Filters"
        },
        stickHeaderOnScroll: {
            type: Boolean,
            required: false,
            default: true,
        },
        showExpandOption: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    data () {
        return {
            showAdvancedFilters: false,
        };
    },

    methods: {
        toggleAdvancedFilters (override = null) {
            if (override !== null) {
                this.showAdvancedFilters = override;
                return;
            }
            this.showAdvancedFilters = !this.showAdvancedFilters;
        },

        applyFilters () {
            this.toggleAdvancedFilters(false);
            this.$emit("apply-filters");
        }
    }
};
</script>

<style scoped>
.stick-below-nav {
    position: sticky !important;
    top: 78px !important;
}

.slide-enter-active {
    -moz-transition-duration: 0.5s;
    -webkit-transition-duration: 0.5s;
    -o-transition-duration: 0.5s;
    transition-duration: 0.5s;
    -moz-transition-timing-function: ease-in-out;
    -webkit-transition-timing-function: ease-in-out;
    -o-transition-timing-function: ease-in-out;
    transition-timing-function: ease-in-out;
}

.slide-leave-active {
    -moz-transition-duration: 0.5s;
    -webkit-transition-duration: 0.5s;
    -o-transition-duration: 0.5s;
    transition-duration: 0.5s;
    -moz-transition-timing-function: ease-in-out;
    -webkit-transition-timing-function: ease-in-out;
    -o-transition-timing-function: ease-in-out;
    transition-timing-function: ease-in-out;
}

.slide-enter-to, .slide-leave {
    max-height: 400px;
    overflow: hidden;
}

.slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
}
</style>
